import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Magnifier = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsxs("g", { fillRule: "evenodd", children: [_jsx("path", { d: "M8.125 12.083c2.49 0 4.375-1.937 4.375-4.166S10.614 3.75 8.125 3.75c-2.49 0-4.375 1.937-4.375 4.167s1.886 4.166 4.375 4.166m0 2.5C11.922 14.583 15 11.6 15 7.917c0-3.682-3.078-6.667-6.875-6.667S1.25 4.235 1.25 7.917s3.078 6.666 6.875 6.666" }), _jsx("path", { d: "M11.2 11.2a1.25 1.25 0 0 1 1.767 0l5.417 5.416a1.25 1.25 0 0 1-1.768 1.768L11.2 12.967a1.25 1.25 0 0 1 0-1.768Z" })] }) }));
});
Magnifier.displayName = 'Magnifier';
Magnifier.__iconComponentType = 'standard';
export default Magnifier;
//# sourceMappingURL=Magnifier.js.map